<template>
  <div class="order-summary-card mt-4">
    <div class="card bg-light">
      <div class="card-body d-flex flex-column p-3">
        <h6 class="card-title mb-3">Order Summary</h6>
        
        <div v-if="hasShippingFee" class="d-flex justify-content-between mb-2">
          <span class="text-muted">Shipping Fee</span>
          <span>${{ $filters.moneyFormat(shippingFee) }}</span>
        </div>

        <div class="d-flex justify-content-between mb-2">
          <span class="text-muted">Total Items</span>
          <span>{{ totalQuantity }}</span>
        </div>

        <div class="d-flex justify-content-between fw-bold">
          <span>Grand Total</span>
          <span>${{ $filters.moneyFormat(totalAmount) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileOrderSummary',
  props: {
    hasShippingFee: {
      type: Boolean,
      default: false
    },
    shippingFee: {
      type: Number,
      default: 0
    },
    totalQuantity: {
      type: Number,
      required: true
    },
    totalAmount: {
      type: Number,
      required: true
    }
  }
}
</script>

<style scoped>
.order-summary-card .card {
  border-radius: 8px;
  border: 1px solid #dee2e6;
}
</style>